var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.outOfDate)?_c('el-alert',{staticClass:"out-of-date-banner",attrs:{"type":"error","show-icon":"","closable":false,"title":_vm.banner}},[_c('el-button',{attrs:{"size":"mini","type":"primary"},on:{"click":_vm.reload}},[_vm._v(_vm._s(_vm.reloadLabel))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }